import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipeVideoPlugin from "photoswipe-video-plugin";
import "photoswipe/style.css";

const lightbox = new PhotoSwipeLightbox({
  gallery: "#my-gallery",
  children: "a",
  showHideAnimationType: "zoom",
  pswpModule: () => import("photoswipe"),
  paddingFn: (viewportSize) => {
    return {
      top: 30,
      bottom: 30,
      left: 70,
      right: 70,
    };
  },
});
const videoPlugin = new PhotoSwipeVideoPlugin(lightbox, {
  // options
});

lightbox.init();


$(".btn-back").on("click", function(){
  let url = window.location.href;
  url = url.substring(0, url.lastIndexOf('/'));
  window.sessionStorage.setItem("activeDataFromPageOfNews", true);

  window.open(url,'_self');
})
